import React from "react";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="w-full pt-48 pb-32 px-6 lg:px-12 min-h-[70vh] max-w-4xl mx-auto">
      <h1 className="text-5xl md:text-6xl font-bold tracking-tighter mb-10">Informativa privacy</h1>
      <p className="text-xl font-light text-gray-600 mb-6">L'informativa sul trattamento dei dati personali è in fase di preparazione e sarà pubblicata a breve.</p>
      <p className="text-lg font-light text-gray-600">
        Titolare del trattamento: Izosmart S.r.l., Viale al Parco 3, 38063 Avio (TN). Per qualsiasi richiesta scrivi a{" "}
        <a href="mailto:info@izosmart.com" className="underline hover:text-[#7dba00]">info@izosmart.com</a>.
      </p>
    </div>
  );
}
